import { render } from "./kaipiao_detail.vue?vue&type=template&id=f0f92814&scoped=true"
import script from "./kaipiao_detail.vue?vue&type=script&lang=js"
export * from "./kaipiao_detail.vue?vue&type=script&lang=js"

import "./kaipiao_detail.vue?vue&type=style&index=0&id=f0f92814&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f92814"]])

export default __exports__